(function () {
  var CUR = '\u00a3';
  function money(cents) { return CUR + (cents / 100).toFixed(2).replace(/\.00$/, ''); }
  function init(root) {
    root.querySelectorAll('[data-pdp]').forEach(function (pdp) {
      if (pdp.dataset.ready) return; pdp.dataset.ready = '1';
      if (pdp.dataset.cur) CUR = pdp.dataset.cur;
      var dataEl = pdp.querySelector('[data-variants]');
      var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
      var idInput = pdp.querySelector('[data-variant-id]');
      var btns = [].slice.call(pdp.querySelectorAll('[data-opt-btn]'));
      var addBtn = pdp.querySelector('[data-add]');
      var priceEl = pdp.querySelector('[data-price]');
      var compareEl = pdp.querySelector('[data-compare]');
      var avail = pdp.querySelector('[data-availability]');
      var img = pdp.querySelector('[data-stage-img]');
      var thumbs = [].slice.call(pdp.querySelectorAll('[data-thumb]'));
      var current = variants.find(function (v) { return String(v.id) === (idInput && idInput.value); }) || variants[0];

      function showImage(src, alt, mediaId) {
        if (!img || !src) return;
        img.removeAttribute('srcset'); img.src = src; if (alt) img.alt = alt;
        thumbs.forEach(function (t) { t.classList.toggle('is-active', String(t.dataset.mediaId) === String(mediaId) || t.dataset.src === src); });
      }
      thumbs.forEach(function (t) { t.addEventListener('click', function () { showImage(t.dataset.src, t.dataset.alt, t.dataset.mediaId); }); });
      if (img && thumbs.length > 1) {
        var step = function (d) { var i = thumbs.findIndex(function (t) { return t.classList.contains('is-active'); }); var n = thumbs[(Math.max(i, 0) + d + thumbs.length) % thumbs.length]; showImage(n.dataset.src, n.dataset.alt, n.dataset.mediaId); };
        img.addEventListener('click', function (e) { var r = img.getBoundingClientRect(); step(e.clientX - r.left < r.width / 3 ? -1 : 1); });
        var sx = null;
        img.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
        img.addEventListener('touchend', function (e) { if (sx === null) return; var dx = e.changedTouches[0].clientX - sx; sx = null; if (Math.abs(dx) > 40) step(dx < 0 ? 1 : -1); });
      }

      // savings label for 2-mask options
      function setSavings() {
        if (!current || !current.options) return;
        pdp.querySelectorAll('[data-save-for]').forEach(function (el) {
          var val = el.dataset.saveFor, idx = +el.closest('[data-option-index]').dataset.optionIndex;
          var want = current.options.slice(); want[idx] = val;
          var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === want[i]; }); });
          var oneVal = null;
          pdp.querySelectorAll('[data-option-index="' + idx + '"] [data-opt-btn]').forEach(function (b) { if (/\b1\b/.test(b.dataset.value)) oneVal = b.dataset.value; });
          el.textContent = v ? v.priceText : '';
          if (!v || !oneVal || val === oneVal) return;
          var m = val.match(/(\d+)/); var n = m ? +m[1] : 0; if (n < 2) return;
          var w1 = current.options.slice(); w1[idx] = oneVal;
          var single = variants.find(function (x) { return x.options.every(function (o, i) { return o === w1[i]; }); });
          if (single && single.price * n > v.price) el.textContent = v.priceText + ' (save ' + money(single.price * n - v.price) + ')';
        });
      }

      function update(v) {
        if (!v) return; current = v;
        if (idInput) idInput.value = v.id;
        btns.forEach(function (b) { var on = v.options[+b.dataset.index] === b.dataset.value; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', String(on)); });
        pdp.querySelectorAll('[data-option-current]').forEach(function (el) { el.textContent = v.options[+el.dataset.optionCurrent] || ''; });
        if (priceEl) priceEl.textContent = v.priceText;
        if (compareEl) { compareEl.hidden = !v.compare; compareEl.textContent = v.compare || ''; }
        if (addBtn) { addBtn.disabled = !v.available; addBtn.textContent = v.available ? 'Add to bag · ' + v.priceText : 'Sold out'; }
        var sp = pdp.querySelector('[data-sticky-price]'); if (sp) sp.textContent = v.priceText;
        if (avail) avail.textContent = v.available ? '' : 'This option is sold out right now.';
        if (v.image) showImage(v.image, null, v.mediaId);
        setSavings();
        if (location.pathname.indexOf('/products/') > -1 && history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u); }
      }
      btns.forEach(function (b) {
        b.addEventListener('click', function () {
          var idx = +b.dataset.index, want = current.options.slice(); want[idx] = b.dataset.value;
          var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === want[i]; }); }) || variants.find(function (x) { return x.options[idx] === b.dataset.value; });
          update(v);
        });
      });
      setSavings();

      // sticky add-to-bag on mobile once the main button scrolls away
      var sticky = pdp.querySelector('[data-sticky]');
      if (sticky && addBtn && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (es) { var e = es[0]; sticky.hidden = e.isIntersecting || e.boundingClientRect.top > 0; }).observe(addBtn);
        sticky.querySelector('[data-sticky-add]').addEventListener('click', function () { addBtn.click(); });
      }
    });
  }
  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
